<div class="container mx-auto p-6">
  <h1 class="text-2xl font-bold mb-6">AI Engine - View Content</h1>
  
  <!-- Content Type Selector -->
  <div class="bg-white rounded-lg shadow-md p-4 mb-6">
    <h2 class="text-lg font-semibold mb-3">Select Content Type</h2>
    <div class="flex flex-wrap gap-2">
      <button 
        *ngFor="let type of contentTypes"
        mat-raised-button
        [color]="selectedContentType === type ? 'primary' : 'basic'"
        (click)="selectContentType(type)"
        class="capitalize">
        {{ getContentTypeLabel(type) }}
      </button>
    </div>
  </div>
  
  <!-- Content Display Area -->
  <div class="bg-white rounded-lg shadow-md p-6">
    <h2 class="text-lg font-semibold mb-4">{{ getContentTypeLabel(selectedContentType) }}</h2>
    
    <!-- Placeholder content based on selected type -->
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      <div 
        *ngFor="let item of [1,2,3,4,5,6]" 
        class="border rounded-lg p-4 flex flex-col items-center">
        <div class="bg-gray-200 border-2 border-dashed rounded-xl w-16 h-16 mb-2 flex items-center justify-center">
          <mat-icon *ngIf="selectedContentType === 'text'">text_snippet</mat-icon>
          <mat-icon *ngIf="selectedContentType === 'image'">image</mat-icon>
          <mat-icon *ngIf="selectedContentType === 'video'">videocam</mat-icon>
          <mat-icon *ngIf="selectedContentType === 'avatar'">account_circle</mat-icon>
          <mat-icon *ngIf="selectedContentType === 'analysis'">analytics</mat-icon>
        </div>
        <p class="text-sm text-center">Generated {{ selectedContentType }} {{ item }}</p>
        <p class="text-xs text-gray-500 mt-1">Created: Just now</p>
      </div>
    </div>
    
    <div class="mt-6 text-center text-gray-500" *ngIf="[1,2,3,4,5,6].length === 0">
      <p>No {{ selectedContentType }} content generated yet.</p>
      <p class="mt-2">Go to <a routerLink="/pages/ai-engine/new-content" class="text-blue-500 hover:underline">New Content</a> to create some!</p>
    </div>
  </div>
</div>